<script setup>
const { locale } = useI18n()

const cv = Math.random().toString(36).substring(7)

const story = await useAsyncStoryblok('home', {
  version: 'publish',
  language: locale.value,
  // cv,
})
useSeoMeta({
  title: story.value?.content.title,
  keyword: story.value?.content.keyword,
  ogTitle: story.value?.content.title,
  ogType: 'website',
  description: story.value?.content.description,
  ogDescription: story.value?.content.description,
  ogImage: story.value?.content.thumbnail?.filename,
  ogUrl: 'https://www.dexon-technology.com/',
  twitterTitle: story.value?.content.title,
  twitterImage: story.value?.content.thumbnail?.filename,
  twitterDescription: story.value?.content.description,
  twitterCard: 'summary_large_image',
})
</script>

<template>
  <div class="overflow-hidden">
    <StoryblokComponent v-if="story" :blok="story.content" />
  </div>
</template>
